export default class Authorization {
  static ROLES() {
    return {
      betrieb: 'BLV-eltra.BETRIEB',
      admin: 'BLV-eltra.ADMIN'
    }
  }
}
